export default __webpack_public_path__ + "static/media/logo1.327a2f83.png";